module.exports = __webpack_public_path__ + "static/media/mdi_format_align_right.82adb5ee.svg";